import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getApiUrl } from './api/client';

// Import translation files
import en from './locales/en.json';
import de from './locales/de.json';

// Load additional translations from API
const loadStoredTranslations = async (lang) => {
  try {
    const response = await fetch(getApiUrl(`/api/locales/${lang}`));
    if (response.ok) {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error('Failed to load locales from API:', error);
  }
  return {};
};

// Initialize with static translations, then load from API
const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
};

// Load additional translations after i18n init
const loadAdditionalTranslations = async () => {
  const [enExtras, deExtras] = await Promise.all([
    loadStoredTranslations('en'),
    loadStoredTranslations('de')
  ]);

  i18n.addResourceBundle('en', 'translation', enExtras, true, true);
  i18n.addResourceBundle('de', 'translation', deExtras, true, true);
};

// Language persistence: stored in localStorage, no /de or /en URL prefixes
const LANGUAGE_STORAGE_KEY = 'tafelberg-lang';

const getInitialLanguage = () => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === 'de' || stored === 'en') return stored;
  } catch (error) {
    // localStorage unavailable - fall back to default
  }
  return 'de';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // restored from localStorage, default 'de'
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

// Persist every language change to localStorage
i18n.on('languageChanged', (lng) => {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch (error) {
    // ignore storage errors
  }
  document.documentElement.setAttribute('lang', lng);
});
document.documentElement.setAttribute('lang', i18n.language);

// Load additional translations from API
loadAdditionalTranslations();

export default i18n;